module.exports = __webpack_public_path__ + "static/img/justboilme.81faca5.png";


//////////////////
// WEBPACK FOOTER
// ./docs/assets/expo/justboilme.png
// module id = 940
// module chunks = 2 8